import React from 'react';

/** Topic pill bar + the scrollable HTML content area for the active section. */
export default function HelpContent({ section, activeTopic, onTopicChange }) {
  const currentTopic = section.topics.find((t) => t.id === activeTopic) || section.topics[0];

  return (
    <div className="help-content">
      <div className="help-content__pills">
        {section.topics.map((topic) => (
          <button
            key={topic.id}
            type="button"
            className={`help-pill${currentTopic?.id === topic.id ? ' is-active' : ''}`}
            onClick={() => onTopicChange(topic.id)}
            aria-pressed={currentTopic?.id === topic.id}
          >
            {topic.title}
          </button>
        ))}
      </div>
      <div className="help-content__body">
        {currentTopic ? (
          <>
            <h3 className="help-content__topic-title">{currentTopic.title}</h3>
            {/* Content is trusted, authored help copy from helpData.js. */}
            <div className="help-html" dangerouslySetInnerHTML={{ __html: currentTopic.body }} />
          </>
        ) : (
          <p className="text-muted">Select a topic to read.</p>
        )}
      </div>
    </div>
  );
}
